import React, { useEffect } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles/';
import Preloader from '../common/Preloader/Preloader';
import ObjectCardContainer from '../common/ObjectCard/ObjectCardContainer';
import ObjectsTable from '../common/ObjectsTable/ObjectsTable';
import SearchObjectsContainer from '../common/SearchObjects/SearchObjectsContainer';
import { useUserRole } from '../../App';
import Typography from '@material-ui/core/Typography';

const Objects = (props) => {
  const { objects, getObjectsList } = props;
  const userRole = useUserRole();

  useEffect(() => {
    if (!objects && (userRole !== 'MODERATOR')) {
      getObjectsList();
    }
  }, [getObjectsList, objects, userRole]);

  if (!userRole || (!objects && userRole !== 'MODERATOR')) {
    return <Preloader loading={true} text={'Загрузка...'}/>;
  }
  if (userRole === 'MODERATOR') {
    return (
      <div className='main'>
        <div className='container-fluid'>
          <SearchObjectsContainer/>
        </div>
      </div>
    );
  }
  return (
    <div className='main'>
      <div className='container-fluid'>
        {userRole !== 'MODERATOR' && (
          <Typography variant='h4' component='h4' className='mb-2'>
            Ваши объекты
          </Typography>
        )}

        <ObjectsTable objects={objects}>
          {objects &&
            Object.keys(objects).map((object) => (
              <ObjectCardContainer key={object} {...objects[object]} />
            ))}
        </ObjectsTable>
      </div>
    </div>
  );
};

export default Objects;
